import request from '@/utils/request'
import { Api as api } from '@/common/config'

/**
 * 获取广告列表
 */
export function getAdvertList(data) {
  return request({
    url: api + '/api/slideshow/list',
    method: 'post',
    data
  })
}
export function studyAdd(data) {
  return request({
    url: api + '/api/courseUserResult/studyAdd',
    method: 'post',
    data
  })
}

/**
 * 获取公告列表
 */
export function getNoticeList(data) {
  return request({
    url: api + '/api/announcements/list',
    method: 'post',
    data
  })
}

/**
 * 获取我的消息列表
 */
export function getMessageNumber(data) {
  return request({
    url: api + '/api/message/messageNum',
    method: 'post',
    data
  })
}

/**
 * 获取我的消息列表
 */
export function getMessageList(data) {
  return request({
    url: api + '/api/message/list',
    method: 'post',
    data
  })
}

/**
 * 获取公告详情
 */
export function getNoticeDetail(data) {
  return request({
    url: api + '/api/announcements/detail',
    method: 'post',
    data
  })
}

/**
 * 最近学习课程
 */
export function getRecentCourses(data) {
  return request({
    url: api + '/api/courseUserResult/recentCourses',
    method: 'post',
    data
  })
}

/**
 * 获取学分信息
 */
export function getStudyCompletedAndNeed(data) {
  return request({
    url: api + '/api/studyRemind/completedAndNeed',
    method: 'post',
    data
  })
}

/**
 * 学习提醒列表
 */
export function getStudyRemindList(data) {
  return request({
    url: api + '/api/studyRemind/list',
    method: 'post',
    data
  })
}

/**
 * 学习提醒新增
 */
export function addStudyRemind(data) {
  return request({
    url: api + '/api/studyRemind/add',
    method: 'post',
    data
  })
}

/**
 * 学习提醒删除
 */
export function deleteStudyRemind(data) {
  return request({
    url: api + '/api/studyRemind/delete',
    method: 'post',
    data
  })
}

/**
 * 学习提醒-已学学分列表
 */
export function getStudyCompletedList(data) {
  return request({
    url: api + '/api/studyRemind/completedList',
    method: 'post',
    data
  })
}

/**
 * 课程首页列表
 */
export function getIndexCourseList(data) {
  return request({
    url: api + '/api/course/indexCourse',
    method: 'post',
    data
  })
}
// 直播
export function getIndexLiveList(data) {
  return request({
    url: api + '/api/course/bigCourse',
    method: 'post',
    data
  })
}

/**
 * 课程列表
 */
export function getCourseList(data) {
  return request({
    url: api + '/api/course/list',
    method: 'post',
    data
  })
}

export function getCourseList2(data) {
  return request({
    url: api + '/api/pointGift/list',
    method: 'post',
    data
  })
}
/**
 * 专家列表
 */
export function getCourseLectorList(data) {
  return request({
    url: api + '/api/courseLector/list',
    method: 'post',
    data
  })
}

/**
 * 专家详情
 */
export function getCourseLectorDetail(data) {
  return request({
    url: api + '/api/courseLector/detail',
    method: 'post',
    data
  })
}

/**
 * 课程分类列表
 */
export function getCourseGroupList(data) {
  return request({
    url: api + '/api/courseGroup/list',
    method: 'post',
    data
  })
}

/**
 * 栏目下课程分类列表
 */
export function getProgramaCourseGroupList(data) {
  return request({
    url: api + '/api/courseGroup/programaGroups',
    method: 'post',
    data
  })
}

/**
 * 课程详情
 */
export function getCourseDeatil(data) {
  return request({
    url: api + '/api/courseUserResult/detail',
    method: 'post',
    data
  })
}

/**
 * 当前直播展示
 */
export function getCourseLiving(data) {
  return request({
    url: api + '/api/course/living',
    method: 'post',
    data
  })
}

/**
 * 课程进度保存
 */
export function studyRecordAdd(data) {
  return request({
    url: api + '/api/courseUserResult/studyAdd',
    method: 'post',
    data
  })
}

/**
 * 短视屏详情
 */
export function getShortVideoDeatil(data) {
  return request({
    url: api + '/api/courseUserResult/watchShortVideos',
    method: 'post',
    data
  })
}

/**
 * 用户课程列表
 */
export function getUserCourseList(data) {
  return request({
    url: api + '/api/courseUserResult/myStudy',
    method: 'post',
    data
  })
}

/**
 * 用户课程记录
 */
export function getCourseWareList(data) {
  return request({
    url: api + '/api/courseWare/list',
    method: 'post',
    data
  })
}

/**
 * 用户课程点赞
 */
export function courseUserLike(data) {
  return request({
    url: api + '/api/courseUserResult/like',
    method: 'post',
    data
  })
}

/**
 * 课程讨论列表
 */
export function getCourseCommentList(data) {
  return request({
    url: api + '/api/courseComment/listComment',
    method: 'post',
    data
  })
}

/**
 * 新增课程讨论
 */
export function addCourseComment(data) {
  return request({
    url: api + '/api/courseComment/add',
    method: 'post',
    data
  })
}

/**
 * 课程提问列表
 */
export function getCourseQuestionList(data) {
  return request({
    url: api + '/api/courseComment/listQues',
    method: 'post',
    data
  })
}

/**
 * 课程评价
 */
export function addCourseEvaluate(data) {
  return request({
    url: api + '/api/courseUserResult/userEvaluate',
    method: 'post',
    data
  })
}

/**
 * 课程附件列表
 */
export function getCourseFileList(data) {
  return request({
    url: api + '/api/courseUserResult/courseFile',
    method: 'post',
    data
  })
}

/**
 * 课程申请
 */
export function addApplyCourse(data) {
  return request({
    url: api + '/api/courseUserResult/applyCourse',
    method: 'post',
    data
  })
}

/**
 * 获取资源列表
 */
export function getResourceList(data) {
  return request({
    url: api + '/api/resource/list',
    method: 'post',
    data
  })
}

/**
 * 获取资源详情
 */
export function getResourceDetail(data) {
  return request({
    url: api + '/api/resource/detail',
    method: 'post',
    data
  })
}

/**
 * 积分兑换课程/资料详情
 */
export function pointGiftDetail(data) {
  return request({
    url: api + '/api/pointGift/detail',
    method: 'post',
    data
  })
}

/**
 * 积分兑换课程/资料
 */
export function addPointLog(data) {
  return request({
    url: api + '/api/userPoint/addPointLog',
    method: 'post',
    data
  })
}

/**
 * 积分兑换记录
 */
export function exchangeRecordList(data) {
  return request({
    url: api + '/api/userPoint/exchangeList',
    method: 'post',
    data
  })
}

/**
 * 删除兑换记录
 */
export function deleteExchangeRecord(data) {
  return request({
    url: api + '/api/userPoint/delete',
    method: 'post',
    data
  })
}

/**
 * 获取会议列表
 */
export function getMeetingList(data) {
  return request({
    url: api + '/api/meeting/list',
    method: 'post',
    data
  })
}

/**
 * 获取会议详情
 */
export function getMeetingDetail(data) {
  return request({
    url: api + '/api/meeting/detail',
    method: 'post',
    data
  })
}

/**
 * 添加会议
 */
export function addMeeting(data) {
  return request({
    url: api + '/api/meeting/add',
    method: 'post',
    data
  })
}

/**
 * 意见反馈
 */
export function addFeedback(data) {
  return request({
    url: api + '/api/feedback/add',
    method: 'post',
    data
  })
}

/**
 * 打赏
 */
export function onlyReward(data) {
  return request({
    url: api + '/api/reward/unifiedOrder',
    method: 'post',
    data
  })
}

/**
 * 意见反馈表列表
 */
export function queryFeedback(data) {
  return request({
    url: api + '/api/feedback/list',
    method: 'post',
    data
  })
}

/**
 * 直播分类
 */
export function courseGroupList(data) {
  return request({
    url: api + '/api/courseGroup/list',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/course.js